import HistoryLauncher from './launcher/history.launcher';
import HistoryWeb from './web/history.web';
import HistoryMock from './mock/history.mock';
import {resolveBridgeType, BridgeType} from './BridgeApi';

export interface HistoryBridge {
    pushUrlHistory(url: string): Promise<void>;
    replaceUrlHistory(url: string): Promise<void>;
    refresh(): Promise<void>;
}

const bridges = {
    [BridgeType.LAUNCHER]: HistoryLauncher,
    [BridgeType.WEB]: HistoryWeb,
    [BridgeType.MOCK]: HistoryMock
};

export default (): HistoryBridge => bridges[resolveBridgeType()];
